import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "./endpoints";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL || "https://api.imparc.site/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 60 * 60,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  endpoints: (builder) => ({
    getTopMenus: builder.query({
      query: () => ({
        url: API_ENDPOINTS.TOP_MENUS,
        method: "GET",
      }),
    }),
    getQuickLinks: builder.query({
      query: () => ({
        url: API_ENDPOINTS.QUICK_LINKS,
        method: "GET",
      }),
    }),
    getAboutMenus: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ABOUT_MENUS,
        method: "GET",
      }),
    }),
    getSiteInformation: builder.query({
      query: () => ({
        url: API_ENDPOINTS.SITE_INFORMATION,
        method: "GET",
      }),
    }),
    getSubjectExpertise: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_SUBJECT_EXPERTISE,
        method: "GET",
      }),
    }),
    getMentorshipOffered: builder.query({
      query: () => ({
        url: API_ENDPOINTS.GET_MENTORSHIP_OFFERED,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetTopMenusQuery,
  useGetQuickLinksQuery,
  useGetAboutMenusQuery,
  useGetSiteInformationQuery,
  useGetSubjectExpertiseQuery,
  useGetMentorshipOfferedQuery,
} = apiSlice;
